// Dependencies

// Styles
require("./fiche-masonry-1-1.scss");
var $ = require("jquery");
$grid = $("[data-isotope-grid]");
$filters = $("[data-isotope-filters]");

if ($grid.length && $filters.length) {
  require("isotope-layout");

  var tags = [];

  $("[data-tag]").each(function (index) {
    tags.push({ tag: $(this).attr("data-tag"), name: $(this).html() });
  });

  const uniq = new Set(tags.map((e) => JSON.stringify(e)));

  const res = Array.from(uniq).map((e) => JSON.parse(e));

  const ordered = res.sort(function (a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  $grid.isotope({
    itemSelector: ".fiche-masonry-1-1__item",
    layoutMode: "fitRows",
  });

  $.each(ordered, function (index, value) {
    $filters.append(
      " <button class='btn btn-sm btn-primary btn-primary-outline btn-not-round' data-filter='." +
        value.tag +
        "'>" +
        value.name +
        "</button> "
    );
  });

  $filters.on("click", "button", function () {
    var filterValue = $(this).attr("data-filter");
    $grid.isotope({ filter: filterValue });
    $filters.find(".btn-primary").addClass("btn-primary-outline");
    $(this).removeClass("btn-primary-outline");
  });
}



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/fiche-masonry-1/view-1/index.js
// module id = 190
// module chunks = 0